// extracted by mini-css-extract-plugin
export default {"part-box-item__info":"part-box-item__info--1d47b9","partBoxItem__info":"part-box-item__info--1d47b9"};